import { isDev } from '@/utils/isDev';

const brandPrefix = process.env.OCELOT_SITE ? `${process.env.OCELOT_SITE.toUpperCase()}_` : '';

export const getAipBffClient = () => {
    const clientId =
        (isDev && process.env[`${brandPrefix}AIP_BFF_CLIENT_ID`]) || process.env.AIP_BFF_CLIENT_ID;
    const clientSecret =
        (isDev && process.env[`${brandPrefix}AIP_BFF_CLIENT_SECRET`]) || process.env.AIP_BFF_CLIENT_SECRET;
    if (!clientId) {
        throw new Error('Missing environment variables: AIP_BFF_CLIENT_ID');
    }
    if (!clientSecret) {
        throw new Error('Missing environment variables: AIP_BFF_CLIENT_SECRET');
    }

    return {
        clientId,
        clientSecret
    };
}
